
export default {
  valueType: 'dateTimeRange',
  FormItemProps: {
    label: '日期时间区间',
    rules: [],
    style: {}
  },
  ControlProps: {
    disabled: false,
    placeholder: ["开始时间", "结束时间"],
    style: {}
  }
}

